import { Dialog, Transition } from '@headlessui/react';
import { IconAlertTriangle } from '@tabler/icons-react';
import { Fragment } from 'react';

export default function ConfirmationDeletePembelian({
  isDelete,
  deletePembelian,
  pembelianDelete,
  isOpenModalDelete,
  closeModalDelete,
}) {
  return (
    <>
      <Transition appear show={isOpenModalDelete} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModalDelete}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center p-4 min-h-[440px]">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-xl bg-white dark:bg-slate-900 border dark:border-slate-700 p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="div"
                    className="text-red-500 flex justify-center font-medium leading-6"
                  ></Dialog.Title>
                  <div>
                    <div className="bg-white dark:bg-slate-900 rounded-lg md:max-w-md">
                      <div className="flex items-center gap-4">
                        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-red-50 dark:bg-red-500/10 flex-shrink-0">
                          <IconAlertTriangle className="text-red-500" width={32} height={32} stroke={1.5} />
                        </div>
                        <div className="mt-4 md:mt-0 md:text-left">
                          <h3 className="text-lg font-bold text-slate-900 dark:text-slate-100">
                            Hapus Pembelian
                          </h3>
                          <p className="text-sm text-slate-600 dark:text-slate-400 mt-1">
                            Apakah Anda yakin ingin <span className="font-semibold text-red-500 dark:text-red-400">menghapus</span>{' '}
                            pembelian dengan faktur{' '}
                            <span className="font-bold text-amber-600 dark:text-amber-500">{pembelianDelete.kode_trx}</span>?
                          </p>
                        </div>
                      </div>
                      <div className="mt-6 flex flex-row gap-3 justify-end border-t border-slate-100 dark:border-slate-800 pt-5">
                        <button
                          onClick={closeModalDelete}
                          className="px-5 py-2.5 text-sm font-medium text-slate-700 bg-white border border-slate-300 hover:bg-slate-50 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-600 dark:hover:bg-slate-700 rounded-lg shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-200 dark:focus:ring-offset-slate-900"
                        >
                          Batal
                        </button>
                        <button
                          onClick={deletePembelian}
                          disabled={isDelete}
                          className="px-5 py-2.5 text-sm font-medium text-white bg-red-600 hover:bg-red-700 dark:bg-red-500 dark:hover:bg-red-600 rounded-lg shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 dark:focus:ring-offset-slate-900 disabled:opacity-70 flex items-center min-w-[100px] justify-center"
                        >
                          {isDelete ? (
                             <>
                               <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                               Proses...
                             </>
                          ) : (
                            'Hapus Data'
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
